import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconRootFn = /* @__PURE__ */ createRecipe('radio-icon-root', {}, [])

const radioOnlyIconRootVariantMap = {}

const radioOnlyIconRootVariantKeys = Object.keys(radioOnlyIconRootVariantMap)

export const radioOnlyIconRoot = /* @__PURE__ */ Object.assign(memo(radioOnlyIconRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconRoot',
  __getCompoundVariantCss__: radioOnlyIconRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconRootVariantKeys,
  variantMap: radioOnlyIconRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconRootVariantKeys)
  },
  getVariantProps: radioOnlyIconRootFn.getVariantProps,
})